let cabinets = document.querySelector(".cabinets");

if (cabinets) {
	let cabinetsCarousel = new Flickity(cabinets, {
		cellAlign: "center",
		contain: true,
		prevNextButtons: false,
		pageDots: true,
		watchCSS: true,
	});
}
